import { Component, Input, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { LineGraphReadingsDataDto } from '../../../data/models/line-graph-data-dto';
import { LineGraphService } from '../../../services/line-graph.service';

@Component({
  selector: 'app-single-graph',
  templateUrl: './single-graph.component.html',
  styleUrls: ['./single-graph.component.scss'],
  providers: [MessageService]
})
export class SingleGraphComponent implements OnInit {

  @Input() readingList: LineGraphReadingsDataDto;
  @Input() graphName: string;
  @Input() interfacesIds: number[];

  chart: any = {};
  chartOptions: any;
  inTraffic: any[] = [];
  outTraffic: any[] = [];
  readingsTime: any[] = [];
  fromDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));
  toDate: Date =  new Date();

  blockUI: boolean = false;
  minSelectableDate: Date;
  maxSelectableDate: Date;
  breadItems: MenuItem[];

  constructor(private graphService: LineGraphService, private messageService: MessageService) {
    this.minSelectableDate = new Date(new Date().setMonth(new Date().getMonth() - 3));
    this.maxSelectableDate = new Date();
}

  ngOnInit() {
    //this.breadItems = [
    //  { label: 'Home', routerLink: '/' },
    //  { label: 'LineDetails' },/* , routerLink: '/linedetails/' + this.tmpid*/
    //  { label: 'Line Log History' }
    //];
  }

  ngAfterViewInit() {
    this.drawChart(this.readingList);
  }

  async drawChart(upDownData: LineGraphReadingsDataDto) {
    let x: any = this.GetTrafficData(upDownData);
    this.destroyChartEvent();
    this.chartOptions = {
      series: [{
        name: 'OutTraffic',
        data: x.__zone_symbol__value.outTraffic //this.outTraffic ////
      },
      {
        name: 'Intraffic',
        data: x.__zone_symbol__value.inTraffic //this.inTraffic //  //
      }],
      chart: {
        height: 350,
        type: "line",
        events: {
          click: (event, chartContext, config) => {
            //this.getGraphStatistics(this.currentSelectedGraph.interfaceId);
          }
        }
      },
      colors: ['#068DA9', 'lightgreen'],
      dataLabels: {
        enabled: false
      },
      title: {
        text: this.graphName
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      tooltip: {
        x: {
          show: true,
          format: 'dd MMM yyyy  HH:mm',
          formatter: undefined,
        },
        y: {
          title: {
            formatter: function (value1, value2) {
              return;
            }
          }

        }
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
        },
        categories: x.__zone_symbol__value.readingTime
      },
      yaxis: {
        labels: {

          formatter: function (value, index) {
            var val = Math.abs(value);
            if (val >= 1000000000) {
              value = (value / 1000000000).toFixed(1) + " Gps";
            }
            else if (val >= 1000000) {
              value = (value / 1000000).toFixed(1) + " Mps";
            }
            else if (val >= 1000 && val < 1000000) {
              value = (value / 1000).toFixed(1) + " Kps";
            }

            else if (val < 1000) {
              value = value + " bps";
            }
            return value;
          }
        }
      },
      toolbar: {
        show: true,

      },
      noData: {
        text: 'No Data Found',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
      }
    };

    this.chart = new ApexCharts(document.querySelector('#graph'), this.chartOptions);
    this.chart.render();
    this.blockUI = false;
  }



  async GetTrafficData(upDownData: LineGraphReadingsDataDto) {
    this.inTraffic = [];
    this.outTraffic = [];
    this.readingsTime = [];

    for (var i = 0; i < upDownData.readings?.length; i++) {
      this.readingsTime.push((upDownData.readings[i].readingTime));
      this.inTraffic.push((upDownData.readings[i].inTraffic));
      this.outTraffic.push((upDownData.readings[i].outTraffic));
    }
    if (upDownData.readings.length == 0) {
      this.inTraffic.push[0];
      this.outTraffic.push[0];
      this.readingsTime.push(this.toDate);

    }
    this.readingsTime.push(new Date(new Date().setHours(new Date().getHours() + 1))); //exceed to one hour to have a clear line 
    let inOutData = { inTraffic: this.inTraffic, outTraffic: this.outTraffic, readingTime: this.readingsTime };
    return inOutData;
  }


  drawLineGraph() {

    this.blockUI = true;
    var toDateAfterOneHour;
    var finalToDate = this.toDate;
    if (this.toDate == new Date()) {
      toDateAfterOneHour = new Date(new Date().setHours(new Date().getHours() + 1));
      finalToDate = toDateAfterOneHour;
    }
    this.graphService.getLineGraphDataReadings(this.interfacesIds, this.fromDate, finalToDate).subscribe((readingResult: LineGraphReadingsDataDto) => {
      if (readingResult) {
        this.readingList = readingResult;
        this.drawChart(this.readingList);
      }
      else
        this.blockUI = false;
    }, (error) => {
      this.blockUI = false;
      this.messageService.add({ severity: 'error', summary: 'Get Graph Readings Data', detail: 'sorry could not return Readings of the graph now' })
    })

  }


  destroyChartEvent() {

    if (this.chart instanceof ApexCharts) {
      (<ApexCharts>this.chart).destroy();
    }

  }

  drawWeek() {
    let today = new Date();
    today.setDate(today.getDate() - 7);
    this.fromDate = new Date(today);
    this.drawLineGraph();
  }
  drawMonth() {
    let today = new Date();
    today.setDate(today.getDate() - 30);
    this.fromDate = new Date(today);
    this.drawLineGraph();
  }

}
